import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=0f975882&scoped=true&"
import script from "./Loader.vue?vue&type=script&lang=js&"
export * from "./Loader.vue?vue&type=script&lang=js&"
import style0 from "./Loader.vue?vue&type=style&index=0&id=0f975882&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f975882",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f975882')) {
      api.createRecord('0f975882', component.options)
    } else {
      api.reload('0f975882', component.options)
    }
    module.hot.accept("./Loader.vue?vue&type=template&id=0f975882&scoped=true&", function () {
      api.rerender('0f975882', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/overview/components/Loader.vue"
export default component.exports